module.exports = "/_next/static/images/ico_load.RhrF7TbY.png";